import { render, staticRenderFns } from "./SubmissionReportFooter.vue?vue&type=template&id=2c1a89ff"
import script from "./SubmissionReportFooter.vue?vue&type=script&lang=js"
export * from "./SubmissionReportFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports